export async function showCartAddError(options, opener) {
    try {
        const { openCartAddError } = await import('./cart-add-error.js');
        openCartAddError(options, opener);
    } catch {
        // Keep the explanation available if the optional dialog chunk fails,
        // without navigating away or automatically repeating the add.
        window.alert(
            'Die Rückmeldung des Warenkorbs konnte nicht angezeigt werden. Bitte prüfe deinen Warenkorb, bevor du es erneut versuchst.',
        );
    }
}
